import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AzmoonMaharatDetail_Files_Interface, Empty_AzmoonMaharatDetail_Files_Interface } from 'src/app/Interface/AzmoonMaharatDetail_Files_Interface';
import { AzmoonMaharatDetail_Interface, Empty_AzmoonMaharatDetail_Interface } from 'src/app/Interface/AzmoonMaharatDetail_Interface';
import { AzmoonMaharatDetail_SignIn_Interface, Empty_AzmoonMaharatDetail_SignIn_Interface } from 'src/app/Interface/AzmoonMaharatDetail_SignIn_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { AzmoonMaharatService } from 'src/app/Service/AzmoonMaharat/AzmoonMaharat.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-AzmoonMaharatMainSignInDetail',
  templateUrl: './AzmoonMaharatMainSignInDetail.component.html',
  styleUrls: ['./AzmoonMaharatMainSignInDetail.component.css']
})
export class AzmoonMaharatMainSignInDetailComponent implements OnInit {

  @Input() inner_AzmoonMaharatMain: AzmoonMaharatDetail_SignIn_Interface = Empty_AzmoonMaharatDetail_SignIn_Interface()
  @Input() inner_Del_Filter:string='0'
  @Output() outter_AzmoonMaharatMain = new EventEmitter<number>();

  Token: String = ""
  Filter_title: string = ""
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;
  modalRef_File: any;
  modalRef_File1: any;

  constructor(
    private AzmoonMaharat_Service: AzmoonMaharatService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService
  ) { }


  DataList_AzmoonMaharat: Array<AzmoonMaharatDetail_Interface> = []
  Data_Seleted_Delete: AzmoonMaharatDetail_Interface = Empty_AzmoonMaharatDetail_Interface()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.AzmoonMaharatForm = new FormGroup({
      startDate: new FormControl(null, Validators.required),
      endDate: new FormControl(null, Validators.required),
    })

    this.AzmoonMaharatFileForm = new FormGroup({
      title: new FormControl(null, Validators.required),
      templateSrc: new FormControl(null, Validators.required),
    })

    this.ReadData_AzmoonMaharat()
  }

  ReadData_AzmoonMaharat() {
    this.Procssing = true
    this.AzmoonMaharat_Service.GetSignInDetail(this.inner_AzmoonMaharatMain.id, this.Token).subscribe(
      data => {
        this.DataList_AzmoonMaharat = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  onBack() {
    this.outter_AzmoonMaharatMain.emit(-1);
  }


  openModal(template: TemplateRef<any>, Record: AzmoonMaharatDetail_Interface) {
    this.Data_Seleted_Delete = Record
    this.get_Form_startDate().setValue(Record.startDate)
    this.get_Form_endDate().setValue(Record.endDate)
    this.modalRef_Delete = this.modalService.show(template);
  }

  //#region Form

  AzmoonMaharatForm: FormGroup;

  get_Form_startDate() {
    return this.AzmoonMaharatForm.get('startDate') as FormControl;
  }
  get_Form_endDate() {
    return this.AzmoonMaharatForm.get('endDate') as FormControl;
  }

  //#endregion


  //#region Files
  BaseUrl = environment.BaseUrl + "File/AzmoonMaharat/"
  FileDataLise: Array<AzmoonMaharatDetail_Files_Interface> = []
  OnSubmitFile() {

    var temp: AzmoonMaharatDetail_Files_Interface = Empty_AzmoonMaharatDetail_Files_Interface()
    temp.id = 0
    temp.title = this.get_FormFile_title().value
    temp.templateSrc = this.get_FormFile_templateSrc().value

    this.FileDataLise.push(temp)

    this.Alertify_Service.SuccessMessage("The file was added to the list")
  }

  RemoveFile(id: number) {
    this.FileDataLise.splice(id, 1)
    this.Alertify_Service.SuccessMessage("The file was removed from the list")
  }

  UploadTemplate(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.AzmoonMaharat_Service.uploadFile(formData).subscribe(
      data => {
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("The file was uploaded successfully")
          this.get_FormFile_templateSrc().setValue(data['filename'])
        }
      }
    )

  }

  openModalFile(template: TemplateRef<any>, Record: AzmoonMaharatDetail_Interface) {
    this.Data_Seleted_Delete = Record
    this.get_FormFile_title().setValue("")
    this.get_FormFile_templateSrc().setValue("")
    this.modalRef_File = this.modalService.show(template);
  }
  
  openModalFile1(template: TemplateRef<any>, Record: AzmoonMaharatDetail_Interface) {
    this.Data_Seleted_Delete = Record
    this.modalRef_File1 = this.modalService.show(template);
  }

  //#endregion

  //#region  Form File

  AzmoonMaharatFileForm: FormGroup;

  get_FormFile_title() {
    return this.AzmoonMaharatFileForm.get('title') as FormControl;
  }
  get_FormFile_templateSrc() {
    return this.AzmoonMaharatFileForm.get('templateSrc') as FormControl;
  }

  SubmitRequestSignInFile() {
    this.Procssing = true
    this.modalRef_File.hide()
    this.AzmoonMaharat_Service.SubmitRequestSignInFile(
      this.Data_Seleted_Delete.id,
      this.get_FormFile_title().value,
      this.get_FormFile_templateSrc().value,
      this.Token).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
          this.ReadData_AzmoonMaharat()
        }
      )
  }

  DeleteRequestSignInFile(item:AzmoonMaharatDetail_Interface) {
    this.modalRef_File.hide()
    this.Procssing = true
    this.AzmoonMaharat_Service.DeleteRequestSignInFile(
      item.id,
      this.Token).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
          this.ReadData_AzmoonMaharat()
        }
      )
  }

  //#endregion



  SubmitRequestSignIn() {
    this.AzmoonMaharat_Service.SubmitRequestSignIn(
      this.Data_Seleted_Delete.id,
      this.get_Form_startDate().value,
      this.get_Form_endDate().value,
      this.Token).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
          this.ReadData_AzmoonMaharat()
        }
      )
  }
}
